import { render, staticRenderFns } from "./ApplyModifierToItem.vue?vue&type=template&id=e5b812e6"
import script from "./ApplyModifierToItem.vue?vue&type=script&lang=js"
export * from "./ApplyModifierToItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports